module.exports = __webpack_public_path__ + "static/media/pro8.4e4586ba.jpg";